// src/helpers.ts

export const getApiUrl = () => {
  if (process.env.NODE_ENV === "development") {
    console.log("Dev mode - using local GraphQL endpoint: http://localhost:4000/graphql");
    return "http://localhost:4000/graphql";
  }

  console.log("Production - using GraphQL endpoint: https://business-builder-backend-sy9bw.ondigitalocean.app/graphql");
  return "https://business-builder-backend-sy9bw.ondigitalocean.app/graphql";
};

/**
 * Ensures an IPFS gateway URL has the https:// protocol.
 */
export const normalizeIpfsUrl = (url: string): string => {
  if (!url) return url;
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  if (url.includes('files.tommillerservices.com')) {
    return `https://${url}`;
  }
  return url;
};

/**
 * Normalizes a media URL for display.
 */
export const normalizeMediaUrl = (url?: string): string => {
  if (!url) return '';
  return normalizeIpfsUrl(url);
};
